import { Injectable, OnDestroy } from '@angular/core';
import { ActivatedRouteSnapshot, EventType, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RoutingUtilsService implements OnDestroy {

  get moduleId() {
    return this._moduleId;
  }

  private _moduleId?: string;
  private _unsubscribe$: Subject <void> = new Subject()

  constructor(
    private readonly router: Router
  ) {
    this.router.events
    .pipe(takeUntil(this._unsubscribe$))
    .subscribe(e => {
      if(e.type === EventType.NavigationEnd) {
        this._moduleId = e.url?.split('/')[1];
      }
    })
  }

  getStringUrl(routeSnapshot: ActivatedRouteSnapshot): string {
    const url = routeSnapshot?.pathFromRoot
        .reduce((acc: any, curr: ActivatedRouteSnapshot): any => {
        return acc + '/' + curr.url.join('/');
      }, '').replace('//', '/');
    return url;
  }

  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }
}
